<script>
  import { DialogNew, Icon } from '@shopboxai/sb-portal-components';
  export let data = { id: '' };
</script>

<DialogNew {data} on:submit on:close>
  <div slot="header">Delete grid?</div>
  <p slot="content">
    <span style="color:#f64740;font-weight:bold;">CAUTION!</span> This action may cause errors on your website if the grid is still being used!
  </p>
  <button class="primary" slot="primary-action">Delete grid</button>
  <button slot="toggle"><Icon name="delete" /></button>
</DialogNew>
